import type { CostAttachment } from '../types'

export interface ContractRef { id?: string; number: string | null; name: string }
export interface SubmittalOption { id: string; displayNumber: string; title: string; status: string; costContract: ContractRef | null }
export interface PickRow { id: string; label: string; status: string; linkedTo: string | null }

export const contractRefLabel = (c: { number: string | null; name: string }): string => (c.number ? `${c.number} ${c.name}` : c.name)

/** Integrations spec §2.2: the picker hides VOID and this contract's own submittals; another contract's stay visible but disabled. */
export const pickableSubmittals = (items: SubmittalOption[], contractId: string): PickRow[] => items
  .filter((s) => s.status !== 'VOID' && s.costContract?.id !== contractId)
  .map((s) => ({ id: s.id, label: `${s.displayNumber} ${s.title}`, status: s.status, linkedTo: s.costContract ? contractRefLabel(s.costContract) : null }))

/** Integrations spec §3.3: any difference counts — after a restore the current version can be the older one. */
export const attachmentVersionState = (a: Pick<CostAttachment, 'source' | 'version' | 'currentVersion' | 'documentDeleted'>): 'deleted' | 'outdated' | 'current' => {
  if (a.source !== 'DOC_REVISION') return 'current'
  if (a.documentDeleted) return 'deleted'
  return a.currentVersion !== null && a.currentVersion !== a.version ? 'outdated' : 'current'
}

/** "Z tendru": the pro-rata dialog opens only when the new contract has neither price items nor lines from the tender's item. */
export const fromTenderAllocate = (amount: string | null, itemCount: number, lineCount: number): string | null =>
  itemCount > 0 || lineCount > 0 ? null : amount
